import { PATH_URL } from '../utils/config';
import { getToken, removeToken, removeUserData } from '../utils/util';

const request = async (endpoint, method = 'GET', body) => {
  const authToken = getToken();
  if (!authToken && endpoint !== '/seguridad/login') {
    console.log('Redirigiendo a sin token de sesion');
    removeToken();
    removeUserData();
    window.location.href = '/login';
    return;
  }
  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  };
  if (authToken) headers['Authorization'] = `Bearer ${authToken}`;
  const config = {
    method,
    headers,
    credentials: 'include',
    mode: 'cors',
  };
  if (body) config.body = JSON.stringify(body);
  try {
    const response = await fetch(`${PATH_URL}${endpoint}`, config);
    if (!response.ok) {
      if (response.status === 401) {
        removeToken();
        removeUserData();
        alert('Tu sesión ha expirado. Por favor inicia sesión nuevamente.');
        window.location.href = '/login';
        return;
      }
      let errorBody;
      try { errorBody = await response.json(); } catch { errorBody = await response.text(); }
      const error = new Error(`HTTP error! Status: ${response.status}`);
      error.status = response.status;
      error.body = errorBody;
      throw error;
    }
    return response.json();
  } catch (error) {
    if (error.message.includes('CORS')) {
      console.error('Error de CORS: Verifica la configuración del servidor y las URLs permitidas');
    }
    throw error;
  }
}

export const requestForm = async (endpoint, method = 'GET', formData) => {
  const authToken = getToken();
  if (!authToken && endpoint !== '/seguridad/login') {
    console.log('Redirigiendo a sin token de sesion');
    removeToken();
    removeUserData();
    window.location.href = '/login';
    return;
  }
  // No se setea Content-Type, el navegador lo hace automáticamente
  const headers = { 'Accept': 'application/json' };
  if (authToken) headers['Authorization'] = `Bearer ${authToken}`;
  const config = {
    method,
    headers,
    credentials: 'include',
    mode: 'cors',
  };
  if (formData) config.body = formData;
  try {
    const response = await fetch(`${PATH_URL}${endpoint}`, config);
    if (!response.ok) {
      if (response.status === 401) {
        removeToken();
        removeUserData();
        alert('Tu sesión ha expirado. Por favor inicia sesión nuevamente.');
        window.location.href = '/login';
        return;
      }
      let errorBody;
      try { errorBody = await response.json(); } catch { errorBody = await response.text(); }
      const error = new Error(`HTTP error! Status: ${response.status}`);
      error.status = response.status;
      error.body = errorBody;
      throw error;
    }
    return response.json();
  } catch (error) {
    if (error.message.includes('CORS')) {
      console.error('Error de CORS: Verifica la configuración del servidor y las URLs permitidas');
    }
    throw error;
  }
};


export const requestFile = async (endpoint, method = 'GET', accept = '*/*') => {
  const authToken = getToken();
  if (!authToken && endpoint !== '/seguridad/login') {
    console.log('Redirigiendo a sin token de sesion');
    removeToken();
    removeUserData();
    window.location.href = '/login';
    return;
  }
  const headers = {
    'Accept': accept,
  };
  if (authToken) headers['Authorization'] = `Bearer ${authToken}`;
  const config = {
    method,
    headers,
    credentials: 'include',
    mode: 'cors',
  };

  try {
    const response = await fetch(`${PATH_URL}${endpoint}`, config);
    if (!response.ok) {
      if (response.status === 401) {
        removeToken();
        removeUserData();
        alert('Tu sesión ha expirado. Por favor inicia sesión nuevamente.');
        window.location.href = '/login';
        return;
      }
      let errorBody;
      try { errorBody = await response.json(); } catch { errorBody = await response.text(); }
      const error = new Error(`HTTP error! Status: ${response.status}`);
      error.status = response.status;
      error.body = errorBody;
      throw error;
    }
    return response.blob();
  } catch (error) {
    if (error.message.includes('CORS')) {
      console.error('Error de CORS: Verifica la configuración del servidor y las URLs permitidas');
    }
    throw error;
  }
};

export default request;
